export function buildMonthStartFilter(monthStart: string): string {
  return `MonthStarts/MonthStart+eq+datetime${encodeURIComponent(`'${monthStart}T00:00:00'`)}`;
}

export function isMonthlyAttendanceReport(serverURL: string): boolean {
  return serverURL.toLowerCase().includes("monthlycert_1_6");
}
